<template>
  <layout title="Home">
    <div v-if="can_view_stats" class="row">
      <div class="col-sm-3">
        <div class="card shadow">
          <div class="card-body py-3">
            <div class="row">
              <div class="col-md-6 icon-big icon-warning text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  fill="currentColor"
                  class="bi bi-people"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1h7.956a.274.274 0 0 0 .014-.002l.008-.002c-.002-.264-.167-1.03-.76-1.72C13.688 10.629 12.718 10 11 10c-1.717 0-2.687.63-3.24 1.276-.593.69-.759 1.457-.76 1.72a1.05 1.05 0 0 0 .022.004zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10c-1.668.02-2.615.64-3.16 1.276C1.163 11.97 1 12.739 1 13h3c0-1.045.323-2.086.92-3zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                  />
                </svg>
              </div>
              <div class="col-md-6 text-right">
                <p class="card-text mb-0">Students</p>
                <h2 class="card-title">{{ stats.students_count }}</h2>
              </div>
            </div>
            <hr />
            <inertia-link
              class="btn btn-xs btn-light"
              :href="route('users.index')"
            >
              View
            </inertia-link>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="card shadow">
          <div class="card-body py-3">
            <div class="row">
              <div class="col-md-6 icon-big icon-green text-center">
                <svg
                  width="60"
                  height="60"
                  fill="currentColor"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="far"
                  data-icon="chalkboard-teacher"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                  class="svg-inline--fa fa-chalkboard-teacher fa-w-20 fa-7x"
                >
                  <path
                    fill="currentColor"
                    d="M226.79 342.02C199 342.02 192.02 352 160 352c-31.97 0-38.95-9.98-66.79-9.98C21.12 342.02 0 403 0 434.67V472c0 22.09 17.91 40 40 40h240c22.09 0 40-17.91 40-40v-37.33c0-42.72-30.58-92.65-93.21-92.65zM272 464H48v-29.33c0-14.01 8.15-44.65 45.21-44.65 17.24 0 29.56 9.98 66.79 9.98 37.37 0 49.49-9.98 66.79-9.98 37.02 0 45.21 30.58 45.21 44.65V464zM160 320c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zm0-144c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48zM592 0H208c-26.47 0-48 22.25-48 49.59V96c9.69 0 32.27 3.13 48 9.52V48h384v320h-48v-48c0-17.67-14.33-32-32-32H384c-17.67 0-32 14.33-32 32v96h240c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0zm-96 368h-96v-32h96v32z"
                    class=""
                  ></path>
                </svg>
              </div>
              <div class="col-md-6 text-right">
                <p class="card-text mb-0">Classrooms</p>
                <h2 class="card-title">{{ stats.classrooms_count }}</h2>
              </div>
            </div>
            <hr />
            <inertia-link
              class="btn btn-xs btn-light"
              :href="route('classrooms.index')"
            >
              View
            </inertia-link>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="card shadow">
          <div class="card-body py-3">
            <div class="row">
              <div class="col-md-6 icon-big icon-danger text-center">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fal"
                  data-icon="file-certificate"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  class="svg-inline--fa fa-file-certificate fa-w-16 fa-7x"
                  width="60"
                  height="60"
                  fill="currentColor"
                >
                  <path
                    fill="currentColor"
                    d="M497.9 97.98L414.02 14.1c-9-9-21.19-14.1-33.89-14.1H176c-26.5.1-47.99 21.6-47.99 48.09V165.7c-5.97 0-11.94-1.68-24.13-5.03-1.7-.46-3.36-.66-4.96-.66-5.56 0-10.43 2.5-13.66 5.79-17.95 18.26-17.07 17.77-41.7 24.5-6.7 1.81-11.97 7.21-13.78 14.07-6.47 24.67-6.09 24.16-24.02 42.32-4.95 5.04-6.9 12.48-5.08 19.43 6.56 24.38 6.52 24.39 0 48.76-1.82 6.95.12 14.4 5.08 19.45 18 18.15 17.58 17.79 24.02 42.29 1.8 6.88 7.08 12.27 13.78 14.1 1.8.48 2.92.8 4.46 1.21V496c0 5.55 2.87 10.69 7.59 13.61 4.66 2.91 10.59 3.16 15.56.7l56.84-28.42 56.84 28.42c2.25 1.12 4.72 1.69 7.16 1.69h272c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM384.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zM33.28 316.68c5.7-22.3 5.7-30.23.01-52.39 15.65-16.2 19.56-22.98 25.63-45.06 21.57-6.13 28.06-9.92 43.88-25.69 9.8 2.62 16.82 4.15 25.21 4.15 8.28 0 15.25-1.49 25.19-4.16 15.56 15.51 22.49 19.58 43.86 25.68 5.98 21.95 9.71 28.63 25.65 45.07-5.77 22.45-5.76 30 0 52.4-15.62 16.17-19.55 22.96-25.61 44.96-14.63 3.92-24 7.36-37.25 19.36-9.94-4.53-20.78-6.89-31.85-6.89s-21.9 2.36-31.85 6.9c-13.18-11.88-22.56-15.34-37.23-19.33-5.97-21.89-9.72-28.57-25.64-45zm101.89 133.01c-4.5-2.25-9.81-2.25-14.31 0l-40.84 20.42V409.9c.12.12.19.17.31.29 3.75 3.82 8.68 5.79 13.64 5.79 3.5 0 7.02-.98 10.16-2.97 7.25-4.59 15.56-6.88 23.87-6.88s16.62 2.29 23.87 6.86c3.16 2.02 6.68 3.01 10.17 3.01 4.96 0 9.87-1.99 13.63-5.79.13-.13.21-.18.34-.32v60.22l-40.84-20.42zm344.84 14.32c0 8.8-7.2 16-16 16h-256V391.9c1.54-.4 2.65-.71 4.44-1.19 6.7-1.82 11.97-7.22 13.77-14.08 6.47-24.68 6.09-24.16 24.03-42.32 4.95-5.04 6.9-12.49 5.07-19.44-6.53-24.33-6.55-24.34 0-48.76 1.83-6.95-.12-14.4-5.07-19.45-18-18.15-17.58-17.79-24.03-42.29-1.8-6.87-7.07-12.27-13.75-14.09-24.23-6.57-23.89-6.23-41.72-24.52-2.94-2.97-6.78-4.52-10.74-5.16V48.09c0-8.8 7.2-16.09 16-16.09h176.03v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01z"
                    class=""
                  ></path>
                </svg>
              </div>
              <div class="col-md-6 text-right">
                <p class="card-text mb-0">Courses</p>
                <h2 class="card-title">{{ stats.courses_count }}</h2>
              </div>
            </div>
            <hr />
            <inertia-link
              class="btn btn-xs btn-light"
              :href="route('courses.index')"
            >
              View
            </inertia-link>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="card shadow">
          <div class="card-body py-3">
            <div class="row">
              <div class="col-md-5 icon-big icon-info text-center pl-4 pt-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  fill="currentColor"
                  class="bi bi-cloud-upload"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                  />
                </svg>
              </div>
              <div class="col-md-7 text-right">
                <p class="card-text mb-0">Storage</p>
                <h2 class="card-title">
                  {{ storageUsed.usage }}
                  <span class="storage-unit">{{ storageUsed.unit }}</span>
                </h2>
              </div>
            </div>
            <hr />
            <button href="#" disabled class="btn btn-xs btn-light btn-disabled">
              View
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-md-8" id="calendar-container">
        <div class="card shadowx">
          <div class="card-body">
            <div id="calendar"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div v-if="can_view_activities" class="card">
          <div class="card-header">Latest activities</div>
          <div class="card-body">
            <div class="card-text">
              <div class="alert alert-info">No activities</div>
            </div>
          </div>
        </div>

        <div v-if="can_view_notices" class="card">
          <div class="card-header">Notices</div>
          <div class="card-body">
            <div class="card-text">
              <div v-if="!notices.data.length" class="alert alert-info">
                No Notices
              </div>

              <div v-for="notice in notices.data" :key="notice.id">
                <strong>{{ notice.title }}</strong>
                <p>
                  {{
                    notice.notice.length > 150
                      ? notice.notice.substring(0, 150) + "..."
                      : notice.notice
                  }} <span @click="openNoticeModal(notice)" style="cursor: pointer">[open]</span>
                </p>
                <small class="text-muted">
                  {{notice.created_at}}
                </small>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="noticeModal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ selectedNotice && selectedNotice.title }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{ selectedNotice && selectedNotice.notice }}
            <small class="text-muted mt-3">
              {{ selectedNotice && selectedNotice.created_at }}
            </small>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";

export default {
  mounted() {
    var calendarEl = document.getElementById("calendar");

    var calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin],
      events: "classrooms/sessions",
      eventContent: function (arg) {},
      eventDidMount: function (arg) {
        $(arg.el).tooltip({
          html: true,
          title: `<div class="calendar-popover">
              <h5>${arg.event.title}</h5>
              Start: ${arg.event.start.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })} <br/>
              End: ${arg.event.end.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          `,
          container: "#calendar",
        });
      },
    });

    calendar.render();
  },
  computed: {
    storageUsed: function () {
      const storage = {
        usage: 0,
        unit: "KB",
      };
      if (this.stats.storage_usage) {
        [storage.usage, storage.unit] = this.formatBytes(
          this.stats.storage_usage,
          1
        );
      }

      return storage;
    },
  },
  methods: {
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return [parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), sizes[i]];
    },
    openNoticeModal(notice) {
      this.selectedNotice = notice;
      $("#noticeModal").modal("show");
    },
  },
  layout: AppLayout,
  props: {
    stats: Object,
    activities: Object,
    notices: Object,
    can_view_stats: Boolean,
    can_view_activities: Boolean,
    can_view_notices: Boolean,
  },
  data() {
    return {
      selectedNotice: null,
    };
  },
  title: "Home",
};
</script>